<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import formatters from '@/mixins/formatters.js';

import NumberInput from './customNumberInput';

export default {
   name: "PayoutForm",
   components: { DatePicker, NumberInput },
   props: {
      isEditMode: {
         type: Boolean,
         default: false
      },
      dataToEdit: {
         type: Object,
         default: () => ({})
      },
      facilityId: {
         type: Number,
         default: null
      }
   },
   data() {
      return {
         form: {
            id: null,
            facilityId: '',
            payoutDate: '',
            amount: '',
            fee: '',
            processingFee: '',
            total: '',
            vat: '',
            net: '',
            csvFile: null,
            pdfReceiptFile: null,
            status: ''
         },
         statusOptions: [
            { value: 'draft', text: this.$t('admin_page.payout_modal.draft') },
            { value: 'confirmed', text: this.$t('admin_page.payout_modal.confirmed') },
         ],
         csvFileName: '',
         pdfReceiptFileName: '',
         alert: {
            show: false,
            variant: 'success',
            message: ''
         },
      }
   },
   computed: {
      isFormValid () {
         if(this.isEditMode === true) {
            if(
               this.form.payoutDate === '' 
               || this.form.payoutDate === null
               || this.form.amount === ''
               || this.form.fee === '' 
               || this.form.processingFee === '' 
               || this.form.total === '' 
               || this.form.vat === '' 
               || this.form.status === '' 
               || this.form.net === '' 
               || this.form.id == null 
               || this.form.id == ''
            ) { return false; }
         } else {
            if(this.form.payoutDate === '' 
            || this.form.amount === '' 
            || this.form.fee === '' 
            || this.form.processingFee === '' 
            || this.form.total === '' 
            || this.form.vat === '' 
            || this.form.net === '' 
            || this.form.csvFile === ''
            || this.form.pdfReceiptFile === ''
            || this.form.csvFile === null
            || this.form.pdfReceiptFile === null) {
               return false;
            }
         }
         // TODO: may extend to if edit is true the file will not check if valid or not
         return true;
      },
      uploadCsvFileDescriptionText() {
         if(this.isEditMode == true) {
            return this.csvFileName == '' ? "" : this.csvFileName
         } else {
            return this.csvFileName == '' ? this.$t('admin_page.payout_form.file_required_text') : this.csvFileName
         }
      },
      uploadPdfReceiptDescriptionText() {
         if(this.isEditMode == true) {
            return this.pdfReceiptFileName == '' ? "" : this.pdfReceiptFileName
         } else {
            return this.pdfReceiptFileName == '' ? this.$t('admin_page.payout_form.pdf_receipt_required_text') : this.pdfReceiptFileName
         }
      }
   },
   methods: {
      // component setting
      preventNonNumericAndHandleDecimal(event) {
         const key = event.key;
         const inputValue = event.target.value; // Get current value of the input
         
         // Allowed common control keys: Backspace, Tab, Enter, Delete, Left/Right arrow keys
         // Also allow for copy/paste/cut/select all (Cmd for Mac, Ctrl for Windows)
         const allowedControlKeys = [
         'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight'
         ];

         // Check if it's a control key (Ctrl/Cmd, Alt, Shift)
         const isModifierKey = event.metaKey || event.ctrlKey || event.altKey;

         // Allow if it's an allowed common control key
         if (allowedControlKeys.includes(key)) return;

         // Allow common Ctrl/Cmd combinations for copy/paste/cut/select all
         if (isModifierKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return;

         // 1. Allow numbers (0-9)
         if (key >= '0' && key <= '9' && !isModifierKey) return; // Allow the digit

         // 2. Allow a single decimal point '.'
         if (key === '.') {
            // Prevent if a decimal point already exists in the input value
            if (inputValue.includes('.')) {
               event.preventDefault(); // Stop the key press
               return;
            }
            return; // Allow the first decimal point
         }
         
         // If none of the above conditions are met, prevent the default action (typing the character)
         event.preventDefault();
      },
      showAlert(variant = 'success', message) {
         this.alert = {
            show: true,
            variant,
            message,
         };

         setTimeout(() => {
               this.alert.show = false;
         }, 3000);
      },

      processCsvUpload($event) {
         let file = $event.target.files[0]
         this.form.csvFile = file;
         const rawFileName = file.name.split('.')[0];
         this.csvFileName = rawFileName;
      },
      processPdfReceiptUpload($event) {
         let file = $event.target.files[0]
         this.form.pdfReceiptFile = file;
         const rawFileName = file.name.split('.')[0];
         this.pdfReceiptFileName = rawFileName;
      },

      async submitPayoutForm() {
         let formData = new FormData();
         for(const key in this.form) {
            formData.append(key, this.form[key])
         }
         await this.$lionheart.post('/v2/payout', formData)
            .then((response) => {
               if(response.data.success == true) {
                  this.showAlert('success', 'Successfully create/update payout list');
                  if(this.isEditMode != true) {
                     this.resetForm();
                     this.$emit('reloadPayoutList');
                  }
               }
            }).catch((error) => {
               console.log('Error submit form ',error);
               this.showAlert('danger', 'Something went wrong in submitting payout list');
            })
      },
      resetForm() {
         this.form.id = null,
         this.form.payoutDate = '';
         this.form.amount = '';
         this.form.fee = '';
         this.form.processingFee = '';
         this.form.total = '';
         this.form.vat = '';
         this.form.net = '';
         this.form.net = 'draft';
         this.form.csvFile = null;
         this.form.pdfReceiptFileFile = null;
         if (this.$refs.csvFileInput && this.$refs.pdfReceiptFileInput) {
            this.$refs.csvFileInput.value = null;
            this.$refs.pdfReceiptFileInput.value = null;
            this.csvFileName = '';
            this.pdfReceiptFileName = '';
         }
      },

   },
   watch: {
      isEditMode: {
         handler(newVal, oldVal) {
            this.form.payoutDate = '';
            this.form.amount = '';
            this.form.fee = '';
            this.form.processingFee = '';
            this.form.vat = '';
            this.form.total = '';
            this.form.net = '';
            this.form.id = '';
            this.fileName = '';
            this.form.facilityId = this.facilityId ?? null;
            // console.log('data changed:', { oldVal, newVal });
            if(newVal == true) {
               this.form.facilityId    = this.dataToEdit.facility_id;
               this.form.payoutDate    = this.dataToEdit.payout_date;
               this.form.amount        = this.dataToEdit.amount;
               this.form.fee           = this.dataToEdit.fee;
               this.form.processingFee = this.dataToEdit.processing_fee;
               this.form.total         = this.dataToEdit.total;
               this.form.vat           = this.dataToEdit.vat;
               this.form.net           = this.dataToEdit.net;
               this.form.status        = this.dataToEdit.status;
               this.form.id            = this.dataToEdit.id;
            } else {
               this.form.payoutDate = '';
               this.form.amount = '';
               this.form.fee = '';
               this.form.processingFee = '';
               this.form.vat = '';
               this.form.net = '';
               this.form.id = '';
               this.form.facilityId = this.facilityId ?? null;
            }
         },
         immediate: true
      }
   },
   mixins: [formatters],
}
</script>
<template>
   <div>
      <b-alert v-if="alert.show" :variant="alert.variant" show>
         {{ alert.message }}
      </b-alert>
      <div class="container">
         <div class="row">
            <!-- form -->
            <b-form class="form col-sm-12 col-lg-7" @submit.prevent="submitPayoutForm">
               <input type="hidden" v-model="form.id">

               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.payout_date_label')"
                  label-for="input-horizontal"
               >
                  <date-picker v-model="form.payoutDate" valueType="YYYY-MM-DD" :default-value="new Date()" format="YYYY/MM/DD" placeholder="YYYY/MM/DD"></date-picker>
               </b-form-group>

               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.amount_label')"
                  label-for="amount"
               >
                  <NumberInput
                     v-model="form.amount"
                  />
               </b-form-group>

               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.fee_label')"
                  label-for="input-horizontal"
               >
                  <NumberInput
                     v-model="form.fee"
                  />
               </b-form-group>

               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.processing_fee_label')"
                  label-for="input-horizontal"
               >
                  <NumberInput
                     v-model="form.processingFee"
                  />
               </b-form-group>

               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.vat_label')"
                  label-for="input-horizontal"
               >
                  <NumberInput
                     v-model="form.vat"
                  />
               </b-form-group>

               <!-- total -->
               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.total_label')"
                  label-for="input-horizontal"
               >
                  <NumberInput
                     v-model="form.total"
                  />
               </b-form-group>

               <!-- net -->
               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.net_label')"
                  label-for="input-horizontal"
               >
                  <NumberInput
                     v-model="form.net"
                  />
               </b-form-group>

               <!-- csv file -->
               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.file_label')"
                  :description="uploadCsvFileDescriptionText"
                  label-for="input-horizontal"
               >
                  <input @change="processCsvUpload($event)" type="file" ref="csvFileInput" class="form-control"/>
               </b-form-group>

               <!-- pdf receipt -->
               <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  :label="$t('admin_page.payout_form.pdf_receipt_label')"
                  :description="uploadPdfReceiptDescriptionText"
                  label-for="input-horizontal"
               >
                  <input @change="processPdfReceiptUpload($event)" type="file" ref="pdfReceiptFileInput" class="form-control"/>
               </b-form-group>


               <!-- status -->
               <b-form-group
                  v-if="this.isEditMode"
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  content-cols-sm
                  content-cols-lg="9"
                  label-for="status"
                  :label="$t('admin_page.payout_form.status_label')"
               >
                  <b-form-select
                     v-model="form.status"
                     :options="statusOptions"
                     id="status"
                     size="md"
                  >
                     <template #first>
                        <b-form-select-option :value="null" disabled>-- {{ $t('admin_page.payout_form.payout_status_selection_text') }} --</b-form-select-option>
                     </template>
                  </b-form-select>
               </b-form-group>

               <!-- buttons -->
               <div class="d-flex justify-content-end w-full">
                  <div class="d-flex align-items-center mb-3 justify-content-between w-full">
                     <b-button class="mt-4 mr-4" pill size="md" variant="primary" @click="isEditMode == true ? $emit('closeEditFormModal') : $emit('closePayoutListModal')">
                        {{ $t('admin_page.payout_form.back_button') }}
                     </b-button>
      
                     <b-button pill class="mt-4" :style="[isFormValid == true ? '' : 'opacity: .25' ]" rounded size="md" variant="danger" type="submit" :disabled="!isFormValid">
                        {{ $t('admin_page.payout_form.confirm_button') }}
                     </b-button>
                  </div>
               </div>

            </b-form>
         </div>
      </div>
   </div>
</template>

<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>